import React from "react";
import { ShieldCheck, ThumbsUp, CircleHelp, HelpCircle } from "lucide-react";

const MAP = {
  CONFIRMED: { color: "#16a34a", bg: "rgba(22,163,74,0.1)", Icon: ShieldCheck },
  SUPPORTED: { color: "#3b82f6", bg: "rgba(59,130,246,0.1)", Icon: ThumbsUp },
  ASSUMED: { color: "#7c3aed", bg: "rgba(124,58,237,0.1)", Icon: CircleHelp },
  UNKNOWN: { color: "#94a3b8", bg: "rgba(148,163,184,0.12)", Icon: HelpCircle },
};

export default function ConfidenceBadge({ level = "ASSUMED" }) {
  const cfg = MAP[level] || MAP.ASSUMED;
  const { Icon } = cfg;
  return (
    <span
      className="inline-flex items-center gap-1.5 text-[11px] font-semibold tracking-wide px-2.5 py-1 rounded-full"
      style={{ color: cfg.color, background: cfg.bg }}
      data-testid={`confidence-${level.toLowerCase()}`}
    >
      <Icon size={13} /> {level}
    </span>
  );
}
